<template>
	<div class="input-time-selects">
		<select v-model="hour">
			<option disabled value="">{{ $t('labels.general.hour') }}</option>
			<option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}</option>
		</select>
		<select v-model="minute">
			<option disabled value="">{{ $t('labels.general.minute') }}</option>
			<option v-for="minute in minutes" :key="minute" :value="minute">{{ minute }}</option>
		</select>
	</div>
</template>

<script>
export default {
	$_veeValidate: {
		value () {
			return this.$el.value
		},
		name () {
			return this.name
		}
	},
	props: {
		name: String,
		value: {
			type: null,
			default: null
		}
	},
	data () {
		return {
			hour: '',
			minute: '',
			ROUND_VALUE: 5
		}
	},
	computed: {
		hours () {
			const hours = []
			for (let i = 0; i < 24; i++) {
				hours.push(i.toString().padStart(2, 0))
			}
			return hours
		},
		minutes () {
			const minutes = []
			for (let i = 0; i < 60; i += this.ROUND_VALUE) {
				minutes.push(i.toString().padStart(2, 0))
			}
			return minutes
		}
	},
	watch: {
		value: {
			handler (value) {
				const time = this.$moment(value, 'HH:mm')
				if (time.isValid()) {
					this.hour = this.pad(time.format('HH'))
					this.minute = this.pad(Math.round(time.format('mm') / this.ROUND_VALUE) * this.ROUND_VALUE)
				}
			},
			immediate: true
		},
		hour () {
			this.setValue()
		},
		minute () {
			this.setValue()
		}
	},
	methods: {
		setValue () {
			const time = `${this.hour}:${this.minute}`
			const regexp = new RegExp('^[0-5][0-9]:[0-5][0-9]$')
			const value = regexp.test(time) ? time : ''
			this.$emit('input', value)
		},
		pad (value) {
			return value.toString().padStart(2, 0)
		}
	},
	mounted () {
		this.$el.value = this.value
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/extra/InputTimeSelects.vue